<template>
    <div class="bg-gray-100">
        <TopLocationHero title-key="playground.title" static-image-key="playground___hero" />

        <div class="relative mt-4 sm:mt-12 z-1">
            <a id="main-content" class="fixed top-0" tabindex="-1"></a>

            <div class="container hidden sm:block">
                <Breadcrumb :items="breadcrumbItems" />
            </div>

            <TopLocationBackgroundShape1 />
        </div>

        <div class="container relative z-3 mt-12">
            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- INTRO -->
            <!-- * -->
            <Type3Block
                featured
                title-key="playground.intro.title"
                description-key="playground.intro.description"
                static-image-key="playground___intro"
            />

            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- LET'S GO TO THE BALLOON -->
            <!-- * -->
            <Type4Block
                title-key="playground.balloon.title"
                description-key="playground.balloon.description"
                :images="galleryImages3"
                class="mt-16 sm:mt-20"
            />
        </div>

        <!-- * -->
        <!-- * -->
        <!-- * -->
        <!-- ALL TIME BEST PLAYGROUND -->
        <!-- * -->
        <div v-if="galleryImages1" class="relative z-2 mt-16 sm:mt-20">
            <TopLocationBackgroundShape2
                class="top-80 sm:top-96 md:top-80 lg:-top-24 xl:-top-32 2xl:-top-28 3xl:-top-24 -translate-y-1/2 sm:translate-y-0 z-1"
            />
            <Type2Block
                title-key="playground.best.title"
                description-key="playground.best.description"
                :images="galleryImages1"
                class="relative z-1"
            />
        </div>

        <div v-if="galleryImages2" class="container relative mt-16 sm:mt-20 z-3">
            <!-- * -->
            <!-- * -->
            <!-- * -->
            <!-- ACCORDION -->
            <!-- * -->
            <Type5Block :items="galleryImages2" />
        </div>

        <div class="relative z-3 mt-20 sm:mt-32">
            <TopLocationBackgroundShape4 class="-top-16 sm:-top-20 z-1" />
            <div class="container relative z-2">
                <!-- * -->
                <!-- * -->
                <!-- * -->
                <!-- WHAT WE OFFER FOR PARENTS -->
                <!-- * -->
                <Type9Block
                    title-key="playground.for_parents.title"
                    description-key="playground.for_parents.description"
                    static-image-key="playground___for-parents"
                    button-label-key="playground.for_parents.button_label"
                    :button-url="$t('playground.for_parents.button_url')"
                />

                <!-- * -->
                <!-- * -->
                <!-- * -->
                <!-- STATUE -->
                <!-- * -->
                <Type10Block
                    title1-key="playground.statue.title_1"
                    description1-key="playground.statue.description_1"
                    title2-key="playground.statue.title_2"
                    description2-key="playground.statue.description_2"
                    static-image-key="playground___statue"
                    class="mt-16 sm:mt-20"
                />
            </div>
        </div>

        <div class="container relative z-4 mt-16 sm:mt-20">
            <TopLocationProjectPageBanner
                v-if="$t('playground.event_recommendation_button_url').length && false"
                :button-text="$t('playground.event_recommendation_button_label')"
                :button-url="$t('playground.event_recommendation_button_url')"
                label-text-key="playground.event_recommendation_text"
                type="event"
            />

            <TopLocationProjectPageBanner
                :button-text="$t('playground.visit_project_button_label')"
                :button-url="$t('playground.visit_project_button_url')"
                label-text-key="playground.visit_project_text"
                class="mt-4 sm:mt-8"
            />

            <AwardsBlock
                v-if="awards"
                :title="awards.title"
                :description="awards.description"
                :media="awards.media"
                class="mt-16 sm:mt-20"
            />
        </div>
    </div>
</template>

<script>
import TopLocationProjectPageBanner from '@/components/Pages/TopLocation/TopLocationProjectPageBanner.vue';
import AwardsBlock from '@/components/Blocks/AwardsBlock/AwardsBlock.vue';
import TopLocationHero from '@/components/Pages/TopLocation/Hero/Hero.vue';
import Type3Block from '@/components/Blocks/Type3Block/Type3Block.vue';
import Type4Block from '@/components/Blocks/Type4Block/Type4Block.vue';
import Type2Block from '@/components/Blocks/Type2Block/Type2Block.vue';
import Type5Block from '@/components/Blocks/Type5Block/Type5Block.vue';
import Type9Block from '@/components/Blocks/Type9Block/Type9Block.vue';
import Type10Block from '@/components/Blocks/Type10Block/Type10Block.vue';
import TopLocationBackgroundShape1 from '@/components/Pages/TopLocation/TopLocationBackgroundShape1.vue';
import TopLocationBackgroundShape2 from '@/components/Pages/TopLocation/TopLocationBackgroundShape2.vue';
import TopLocationBackgroundShape4 from '@/components/Pages/TopLocation/TopLocationBackgroundShape4.vue';

export default {
    name: 'PlaygroundOfVarosliget',
    components: {
        AwardsBlock,
        TopLocationProjectPageBanner,
        TopLocationBackgroundShape4,
        TopLocationBackgroundShape2,
        TopLocationBackgroundShape1,
        TopLocationHero,
        Type3Block,
        Type4Block,
        Type2Block,
        Type5Block,
        Type9Block,
        Type10Block,
    },
    async asyncData({ $axios, i18n }) {
        let galleryImages1 = null;
        let galleryImages2 = null;
        let galleryImages3 = null;
        let awards = null;

        await Promise.allSettled([
            $axios.$get('/galleries/reference/top-location___playground-1'),
            $axios.$get('/galleries/reference/top-location___playground-2'),
            $axios.$get('/galleries/reference/top-location___playground-3'),
            $axios.$get('/awards/reference/playground'),
        ])
            .then(([galleryImages1Res, galleryImages2Res, galleryImages3Res, awardsRes]) => {
                if (galleryImages1Res.status === 'fulfilled') {
                    galleryImages1 = galleryImages1Res.value.slides;
                }

                if (galleryImages2Res.status === 'fulfilled') {
                    galleryImages2 = galleryImages2Res.value.slides;
                }

                if (galleryImages3Res.status === 'fulfilled') {
                    galleryImages3 = galleryImages3Res.value.slides;
                }

                if (awardsRes.status === 'fulfilled' && awardsRes.value.is_on_top_locations) {
                    awards = awardsRes.value;
                }
            })
            .catch((err) => {
                console.log(err);
            });

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('navigation.top_locations'), 'top-locations', true]);
        breadcrumbItems.push([i18n.t('playground.title'), 'playground-of-varosliget']);

        return {
            galleryImages1,
            galleryImages2,
            galleryImages3,
            awards,
            breadcrumbItems,
        };
    },
    data() {
        return {};
    },
    head() {
        return {
            title: this.$getPageTitle('top-locations.playground'),
            meta: this.$getPageMetaData('top-locations.playground'),
        };
    },
};
</script>

<style scoped></style>
